module.exports = __webpack_public_path__ + "img/a68b3ac.jpg";